import React from 'react';

const ServicesCompany = () => {
  return (
    <div className="services" id="servicos">
      <h2 className="sectionTitle2">Nossos Serviços</h2>
      <div className="allServices">
        <div className="service">
          <div className="titleService">
            <h3>Sites Institucionais:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$250</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>15 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Desenvolvemos sites institucionais com funcionalidades básicas,
              perfeitos para empresas se inserirem no mundo digital de forma
              rápida e profissional. Ideal para apresentar a empresa, seus
              produtos e serviços, fornecer informações de contato e fortalecer
              a marca.
            </p>
          </div>
          <div className="buttonService" id="servise01">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>

        <div className="service">
          <div className="titleService">
            <h3>Sistemas Web:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$400</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>30 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Criamos sistemas web personalizados para empresas, com
              funcionalidades complexas que resolvem problemas desafiadores e
              automatizam processos. Essa é a solução ideal para otimizar tempo,
              reduzir custos e aumentar os ganhos através de uma gestão mais
              eficiente.
            </p>
          </div>
          <div className="buttonService">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>

        <div className="service">
          <div className="titleService">
            <h3>Blog:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$200</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>12 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Desenvolvemos blogs para indivíduos e empresas que produzem
              conteúdo online. Seja para diversão, informação ou monetização, um
              blog oferece uma plataforma acessível e versátil, ideal para
              engajar uma audiência e compartilhar ideias ou conhecimentos.
            </p>
          </div>
          <div className="buttonService">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>

        <div className="service">
          <div className="titleService">
            <h3>Landing Pages:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$100</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>5 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Criamos landing pages focadas em capturar leads e promover
              produtos ou serviços específicos. Com design otimizado para
              conversões, essas páginas são ideais para maximizar o retorno de
              campanhas publicitárias e direcionar visitantes para ações
              específicas.
            </p>
          </div>
          <div className="buttonService">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>

        <div className="service">
          <div className="titleService">
            <h3>Site Pessoal:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$100</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>5 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Criamos seu site pessoal e apresentamos você ao mundo! Seja para
              destacar suas habilidades profissionais ou compartilhar suas
              paixões. Solução ideal para apresentar seu perfil profissional e
              passar maior credibilidade para empresas e clientes.
            </p>
          </div>
          <div className="buttonService">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>

        <div className="service">
          <div className="titleService">
            <h3>Espaço Influencer:</h3>
          </div>
          <div className="priceAndTime">
            <div className="price">
              <h6>A partir de:</h6>
              <p>R$250</p>
            </div>
            <div className="time">
              <h6>Tempo mínimo:</h6>
              <p>10 dias</p>
            </div>
          </div>
          <div className="descripition">
            <h6>Descrição do serviço:</h6>
            <p>
              Este serviço é a solução ideal para influenciadores digitais que
              buscam uma presença online personalizada. Criamos sites sob medida
              para compartilhar produtos, serviços e contatos profissionais,
              transformando sua influência em oportunidades.
            </p>
          </div>
          <div className="buttonService">
            <a href="#solicitarServico" className="blue-button">
              Quero este serviço
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesCompany;
